/**
 * Notification levels
 */
export enum NotificationLevel {
    Info,
    Danger,
    Success,
}
